import React from "react";
import styled from "styled-components";
import { textGradient } from "../GradientBox";
import { LandingPageTemplate } from "./LandingTemplate";

export const ActivityRejuvenatesByLanding: React.FC = () => {
  return (
    <LandingPageTemplate
      header={<Header />}
      illustration={
        <img
          height={330}
          style={{
            marginTop: "-20px",
            marginBottom: "-20px",
          }}
          src="/landing-pages/activity-rejuvenates-by.png"
        />
      }
      androidStoreListing={"ruch_odmladza_o"}
      appStorePpid={"c3bb8026-d5ac-4f33-993e-654919d21bd9"}
    />
  );
};

export default ActivityRejuvenatesByLanding;

const Header: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ContentHeader>
        Obserwuj,
        <br />
        jak ruch Cię
        <br />
        odmładza
      </ContentHeader>
    </div>
  );
};

const ContentHeader = styled.h1`
  font-size: 32px;
  font-weight: bold;
  background: ${textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0px;
`;
